import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { ScrollArea } from "../ui/scroll-area";
import { CheckCircle2, XCircle, AlertTriangle, Clock, BookOpen } from "lucide-react";

const formatLatency = (ms) => {
  if (!ms) return null;
  return ms >= 1000 ? `${(ms / 1000).toFixed(1)}s` : `${ms}ms`;
};

export const StepsList = ({ stepResults, steps, activeStep, onSelectStep }) => {
  return (
    <Card className="lg:col-span-1" data-testid="steps-list">
      <CardHeader>
        <CardTitle className="text-base">Verification Steps</CardTitle>
        <CardDescription>{stepResults.length}-step quality check</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        <ScrollArea className="h-[500px]">
          <div className="p-4 space-y-1">
            {stepResults.map((sr, index) => {
              const step = steps.find(s => s.id === sr.step_id);
              const isActive = index === activeStep;

              return (
                <button
                  key={sr.step_id}
                  onClick={() => onSelectStep(index)}
                  className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition-colors ${
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "hover:bg-muted"
                  }`}
                  data-testid={`step-btn-${index + 1}`}
                >
                  <div className={`step-indicator ${sr.status} ${isActive ? 'active' : ''}`}>
                    {sr.status === "pending" ? (
                      <span>{index + 1}</span>
                    ) : sr.status === "pass" ? (
                      <CheckCircle2 className="w-4 h-4" />
                    ) : sr.status === "fail" ? (
                      <XCircle className="w-4 h-4" />
                    ) : (
                      <AlertTriangle className="w-4 h-4" />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate">
                      {sr.step_name}
                    </p>
                    <p className={`text-xs truncate ${isActive ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                      {step?.cv_task || "Verification"}
                    </p>
                    {formatLatency(sr.ai_elapsed_ms) && (
                      <p className={`text-xs flex items-center gap-1 mt-0.5 ${isActive ? "text-primary-foreground/60" : "text-muted-foreground/70"}`}>
                        <Clock className="w-3 h-3" />
                        {formatLatency(sr.ai_elapsed_ms)}
                      </p>
                    )}
                    {sr.is_optional && (
                      <p className={`text-xs flex items-center gap-1 mt-0.5 ${isActive ? "text-primary-foreground/60" : "text-blue-500"}`}>
                        <BookOpen className="w-3 h-3" />
                        Optional
                      </p>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
